import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ProductList.css";

const productImages = Array.from({ length: 33 }, (_, i) => ({
  id: i + 1,
  src: require(`../../assets/product-images/${i + 1}.png`),
  title: "Spongebob Collector's Cup",
  description: "Playful cups with candies inside",
}));

const ProductList = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const productsPerPage = window.innerWidth <= 768 ? 4 : 12;

  const handleContactClick = () => {
    navigate("/contact");
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(productImages.length / productsPerPage) - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const startIndex = currentPage * productsPerPage;
  const endIndex = startIndex + productsPerPage;
  const currentProducts = productImages.slice(startIndex, endIndex);

  return (
    <section className="product-list-section">
      <h1>Our Best Sellers</h1>
      <button className="product-list-contact-button" onClick={handleContactClick}>
        Contact Us for Orders
      </button>
      <div className="product-list-products">
        {currentProducts.map((product) => (
          <div className="product-list-product" key={product.id}>
            <img src={product.src} alt={product.title} />
            <h2 className="product-list-product-title">{product.title}</h2>
            <p className="product-list-product-description">{product.description}</p>
            <div className="product-list-product-hover">
              <div className="product-list-p-hover-animation">
                <div className="product-list-semi-circle-animation"></div>
              </div>
              <h3 className="product-list-hover-title">{product.title}</h3>
              <button className="product-list-hover-button" onClick={handleContactClick}>
                Order Now
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="product-list-pagination">
        <button
          className="product-list-pagination-button"
          onClick={handlePrevPage}
          disabled={currentPage === 0}
        >
          &larr;
        </button>
        <button
          className="product-list-pagination-button"
          onClick={handleNextPage}
          disabled={currentPage >= Math.ceil(productImages.length / productsPerPage) - 1}
        >
          &rarr;
        </button>
      </div>
    </section>
  );
};

export default ProductList;